import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const View16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 10.5C9.10457 10.5 10 9.60458 10 8.50001C10 7.39544 9.10457 6.50001 8 6.50001C6.89543 6.50001 6 7.39544 6 8.50001C6 9.60458 6.89543 10.5 8 10.5Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8 3.82501C5.22734 3.82501 2.85061 5.08838 1.21293 7.05578C0.515364 7.8938 0.515367 9.10625 1.21294 9.94427C2.85061 11.9116 5.22734 13.175 8 13.175C10.7727 13.175 13.1494 11.9116 14.7871 9.94426C15.4846 9.10625 15.4846 7.8938 14.7871 7.05578C13.1494 5.08838 10.7727 3.82501 8 3.82501ZM2.25051 7.91946C3.65443 6.23288 5.66248 5.17501 8 5.17501C10.3375 5.17501 12.3456 6.23288 13.7495 7.91946C14.0305 8.25704 14.0305 8.74301 13.7495 9.08058C12.3456 10.7672 10.3375 11.825 8 11.825C5.66249 11.825 3.65443 10.7672 2.25051 9.08058C1.96951 8.74301 1.96951 8.25704 2.25051 7.91946Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
